import * as mqtt from 'mqtt/dist/mqtt.min';
import { createContext } from 'react';

export const MqttContext = createContext<mqtt.MqttClient | null>(null as any);
MqttContext.displayName = 'MqttContext';
